import { AiOutlineDelete, AiOutlineQuestionCircle } from "react-icons/ai";
import { FiCreditCard } from "react-icons/fi";
import { cartActions } from "../../store/cart";
import { useSelector } from "react-redux";
import { currencyPipe, datePipe } from "../../Utils/pipes";
import useUser from "../../Context/hook/useUser";
import ReactTooltip from "react-tooltip";
import Logo2 from "../../Assets/img/Cardnet-Logo.png";
import { useState } from "react";
import { useDispatch } from "react-redux";
function Cart({ id, park, sendPayment }) {
  const cart = useSelector((state) => state.cart.cart);
  const fare = useSelector((state) => state.cart.fare);
  const [enable, setEnable] = useState(false);
  const cartTotal = useSelector((state) => state.cart.cartTotal);
  const { getUser } = useUser();
  const dispatch = useDispatch();

  const checkHandler = () => {
    setEnable((e) => !e);
  };

  const sendPaymentHandler = () => {
    sendPayment();
  };

  return (
    <div className="basis-auto tab-land:basis-5/12 small-desktop:basis-4/12">
      <div className="mx-12 mb-10 mt-10 phone:mb-30">
        <p className="text-4xl font-sans">Factura</p>
        <div
          style={{
            overflowY: "scroll",
            paddingRight: "1rem",
            /*minHeight: "8rem",*/ maxHeight: "16rem",
          }}
          className=""
        >
          {cart.map((item, i) => (
            <div key={i}>
              <p className="mt-11 text-2xl">{item.fechaValid}</p>
              <div className="flex justify-between items-center gap-y-2 my-2 flex-row">
                <p className="text-3xl">
                  <span>
                    ${currencyPipe(fare)} x {item.cantidad} Tickets
                  </span>
                </p>
                <p className="text-3xl">
                  <span>${currencyPipe(fare * item.cantidad)}</span>
                </p>

                <button
                  onClick={() => {
                    dispatch(cartActions.removeItem({ id: i }));
                  }}
                >
                  <AiOutlineDelete className="text-4xl text-danger hover:text-dark" />
                </button>
              </div>
              <hr className="my-4 border-bd-light"></hr>
            </div>
          ))}
        </div>
        <div className="dividir-grey"></div>
        {getUser()?.clientTypeId === "CO" ? (
          <>
            <div className="custom-form__control select-container flex flex-row mt-4">
              <label htmlFor="email" className="text-2xl my-2">
                Correo secundario
                <AiOutlineQuestionCircle
                  className="inline ml-1"
                  fontSize={"1.5rem"}
                  fontWeight={500}
                  data-tip="Este correo será utilizado para <br/> el envío de su factura."
                ></AiOutlineQuestionCircle>
              </label>
              <input
                id="email"
                className="select"
                style={{ width: "100%" }}
                placeholder="Correo para recibir la factura"
                onInput={(event) => {
                  // - Change to Redux
                  //  setEmail(event.target.value);
                }}
                type="email"
              />
            </div>
            <ReactTooltip multiline={true} type="info" effect="solid" />
            <div className="dividir-grey"></div>
          </>
        ) : null}
        <div className="flex justify-between flex-col tab-port:flex-row">
          <p className="text-4xl mt-6">Paga con </p>
          <span className="w-[140px] pt-3">
            <img src={Logo2} alt="Logo cardnet" />
          </span>
        </div>
        <div className="mt-12 px-5 flex flex-row">
          <input
            onChange={checkHandler}
            type={"checkbox"}
            className="w-[15vw] h-[3vh] tab-port:w-[3vw] tab-port:h-[3vh] mt-[0.3em]"
          />
          <p className="text-xl px-6 text-justify">
            Acepto todos los&nbsp;
            <a
              href="/#/park/terminos"
              target="_blank"
              className="text-font-light link"
            >
              Términos y Condiciones
            </a>
            , así como también la
            <a
              href="/#/politicas"
              target="_blank"
              className="ml-3 text-font-light link"
            >
              Política de privacidad
            </a>
            &nbsp;del Ministerio de Medio Ambiente y Recursos Naturales.
          </p>
        </div>
        <div className="Contenedor-boton">
          <button
            disabled={!enable ? true : false}
            onClick={sendPaymentHandler}
            className={
              enable
                ? "cursor-pointer py-6 px-32 text-4xl bg-[#003670] text-white rounded-lg"
                : "py-6 px-32 text-4xl bg-[#6e8dae] text-white rounded-lg"
            }
          >
            Pagar ahora <FiCreditCard className="icono inline-block" />
          </button>
        </div>
      </div>
      <div className="dividir"></div>
      <div className="mx-12 mb-12">
        <div className="flex justify-between gap-y-6 flex-col phone:flex-row">
          <p className="text-3xl">{"Total (RD$)"}</p>
          <p className="text-3xl">
            <span>${currencyPipe(cartTotal)}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export { Cart };
